import React, { FunctionComponent, useState } from "react";
import {
  Button,
  ButtonGroup,
  InputAdornment,
  LinearProgress,
  Snackbar,
  TextField,
  Typography,
  useMediaQuery
} from "@material-ui/core";

import useStyles from "./styles";
import { useTheme } from "@material-ui/core/styles";
import { useI18n } from "../../../hooks/useI18n";
// @ts-ignore
import ScanditBarcodeScanner from "scandit-sdk-react";
import { globalSettings } from "../../../models/Settings";
import StoreIcon from "@material-ui/icons/Store";
import { Store } from "../../../models/Store";
import { ScanResult } from "scandit-sdk";
import { Alert } from "@material-ui/lab";
import * as StoreInventoryApi from "../../../api/storeInventoryApi";
import { isOk } from "../../../result";
import CheckIcon from "@material-ui/icons/Check";
import { ConnectToPriceTag } from "./ConnectToPriceTag";
import { Link } from "@material-ui/icons";

interface ProductToPriceTagLinkProps {
  stores: ReadonlyArray<Store>;
  gtin: string;
}

export const ProductToPriceTagList: FunctionComponent<
  ProductToPriceTagLinkProps
> = ({ gtin, stores }) => {
  const { t } = useI18n();
  const classes = useStyles();
  const theme = useTheme();
  const mobile = useMediaQuery(theme.breakpoints.down("xs"));

  const [state, setState] = useState({
    storeId: "",
    showScanner: false,
    loading: false,
    showSuccess: false,
    error: "",
    addedStoreIds: [] as string[]
  });

  return state.showScanner ? (
    <ConnectToPriceTag
      storeId={state.storeId}
      gtin={gtin}
      addToStore={true}
      onSuccess={() =>
        setState({
          ...state,
          showSuccess: true,
          showScanner: false,
          storeId: "",
          addedStoreIds: [...state.addedStoreIds, state.storeId]
        })
      }
      onCancel={() =>
        setState({
          ...state,
          showSuccess: false,
          showScanner: false,
          storeId: ""
        })
      }
    />
  ) : (
    <>
      <Alert style={{ marginTop: 5, marginBottom: 25 }} severity="success">
        The product has been registered successfully and can now be connected to
        a digital price tag
      </Alert>
      {stores.map(s => (
        <ButtonGroup
          key={s.id}
          disableElevation
          variant="outlined"
          aria-label={t("common.tooltip.outlinedButtonGroup")}
          style={{ justifyContent: "center", marginTop: 8, marginBottom: 8 }}
        >
          <Button
            disableRipple
            disableFocusRipple
            disableTouchRipple
            startIcon={<StoreIcon color={"primary"} />}
            style={{
              textTransform: "unset",
              borderColor: theme.palette.primary.light,
              color: "#000",
              minWidth: "40%",
              width: mobile ? "80%" : "",
              justifyContent: "flex-start",
              backgroundColor: "transparent",
              cursor: "default"
            }}
          >
            {s.name}
          </Button>
          {state.addedStoreIds.includes(s.id) ? (
            <Button
              disableRipple
              disableFocusRipple
              disableTouchRipple
              startIcon={
                <CheckIcon style={{ color: theme.palette.success.dark }} />
              }
              style={{
                borderColor: theme.palette.primary.light,
                color: theme.palette.success.dark,
                backgroundColor: "transparent",
                cursor: "default"
              }}
            >
              Price tag connecting
            </Button>
          ) : (
            <Button
              color="primary"
              startIcon={<Link />}
              variant="contained"
              onClick={() =>
                setState({ ...state, showScanner: true, storeId: s.id })
              }
            >
              Connect to price tag
            </Button>
          )}
        </ButtonGroup>
      ))}

      <Snackbar
        open={state.showSuccess}
        autoHideDuration={3000}
        onClose={() => {
          setState({
            ...state,
            showSuccess: false
          });
        }}
      >
        <Alert severity="success">
          Product has been activated in store and pricetag will be connected
          shortly
        </Alert>
      </Snackbar>
    </>
  );
};
